import QuantityControl from './QuantityControl';

export default QuantityControl;
